import { render, staticRenderFns } from "./AuthCredentialsForm.vue?vue&type=template&id=4485f691&scoped=true&lang=pug"
import script from "./AuthCredentialsForm.vue?vue&type=script&lang=js"
export * from "./AuthCredentialsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485f691",
  null
  
)

export default component.exports